import { InputNumber } from 'antd';
import cx from 'classnames';
import React, { useContext } from 'react';
import { DoorStoreSingleContext } from '../../../../../DoorModal/DoorStoreSingleContext';
import { setControlMode, StoreContext } from '../../../../contextExpansionRelay';
import styles from '../../../../expansionRelayModal.module.scss';

type Props = {
	useDoorContext: boolean;
};

const ControlMode: React.FC<Props> = ({ useDoorContext }) => {
	if (useDoorContext) {
		var {
			contextStateDoor: {
				relay: { controlModeTime },
			},
			dispatcherDoor,
		} = useContext(DoorStoreSingleContext);
	} else {
		var {
			expansionRelayState: { controlModeTime },
			dispatcher,
		} = useContext(StoreContext);
	}

	const handleOnChangeControlMode = (value: string) => {
		if (value === '' || value === null || !Number(value.toString())) {
			if (value !== '0') {
				return;
			}
		}

		const formattedValue = Math.floor(Number(value) * 4) / 4;

		useDoorContext ? dispatcherDoor(setControlMode(formattedValue * 4)) : dispatcher(setControlMode(formattedValue * 4));
	};

	const modeTime = controlModeTime / 4;

	return (
		<div className={styles.generalSection}>
			<span>{_('ControlMode')}</span>
			<div>
				<InputNumber
					id='relayGeneralControlModeInput'
					key='controlMode'
					min={0}
					max={8100}
					maxLength={6}
					value={modeTime}
					onChange={value => handleOnChangeControlMode(value.toString())}
					precision={2}
					step={0.25}
					className={cx(styles.input)}
					formatter={value => `${value}`.replace(/[^0-9\.]+/g, '')}
				/>
			</div>
		</div>
	);
};

export { ControlMode };
